module.exports = __webpack_public_path__ + "static/media/horse.17c93eee.svg";